import { includes, toString } from 'lodash';
import parser from 'ua-parser-js';

export const isMobile = () => {
  const deviceType =
    toString(
      typeof window !== 'undefined' &&
        parser(window.navigator.userAgent).device.type
    ) || 'desktop';
  return includes(
    ['mobile', 'iphone', 'android', 'Windows Phone'],
    deviceType.toLowerCase()
  );
};
